import { createPortal } from "react-dom";

function Portal({ children, to }) {
  if (!to) return children;

  return createPortal(children, to);
}

export default Portal;
